<template>
	<div class="gmap google-map-wrapper">
		<gmap-map :center="center" :zoom="zoom" v-bind:options="mapOptions" ref="gmap" style="width: 100%;" v-bind:style="{height: height + 'px' }" v-on:bounds_changed="handleBoundsChanged">
			<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
				<template v-if="infoWindowTemplate === 'default'">
					<div class="marker-info">
						<p class="marker-address">
							<span class="property-address" v-if="info.address" v-html="info.address"></span>
							<span class="property-address2" v-if="info.address_2" v-html="info.address_2"></span>
						</p>
					</div>
				</template>

				<template v-if="infoWindowTemplate === 'property'">
					<div class="marker-info clickable" v-on:click="openProperty(info.id)">
						<p class="marker-address">
							<span class="property-name" v-if="info.property_name">{{ info.property_name }}</span>
							<span class="property-address" v-if="info.address" v-html="info.address"></span>
							<span class="property-address2" v-if="info.address_2" v-html="info.address_2"></span>
						</p>
						<ul>
							<li v-for="(meta, key) in info.meta" :key="key" v-if="meta.value">
								<strong>{{ meta.label }}: </strong> {{ meta.value }}
							</li>
						</ul>
					</div>
				</template>
			</gmap-info-window>

			<gmap-cluster>
				<gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"></gmap-marker>
			</gmap-cluster>
		</gmap-map>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

export default {
  components: {
    GmapCluster
  },
  props: {
    markers: {
      type: Array
    },
    infoWindowTemplate: {
      type: String,
      default: 'default'
    },
    height: {
      type: Number,
      default: 550
    },
    mapType: {
      type: String,
      default: 'hybrid'
    },
    mapZoom: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      zoom: 10, // Default
      center: {
        // This param is required
        // This lat/lng is the center of the USA
        // fitBounds() moves the map view
        lat: 39.8283,
        lng: 98.5795
      },
      mapOptions: {
        styles: [
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
          }
        ],
        minZoom: 4,
        mapTypeId: this.mapType,
        scrollwheel: false
      },
      info: {
        'property_name': '',
        'address': '',
        'address_2': '',
        'meta': []
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  computed: {
    ...mapState({
      gmapsLoaded: 'gmapsLoaded'
    }),
    google: gmapApi
  },
  methods: {
    openProperty: function (propertyId) {
      this.$router.push('/accounts/' + this.$route.params.id + '/properties/' + propertyId)
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.info = marker.info

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    setMapBounds () {
      let bounds = new this.google.maps.LatLngBounds()

      // Loop through every marker and generate map bounds
      // this fits all the markers within the map view
      this.markers.forEach(marker => {
        bounds.extend(
          new this.google.maps.LatLng(
            marker.position.lat,
            marker.position.lng
          ))
      })

      this.$refs.gmap.fitBounds(bounds, 80)
    },
    handleBoundsChanged () {
      if (this.mapZoom === this.zoom) return

      if (this.mapZoom && this.markers.length === 1) {
        this.zoom = this.mapZoom
      }
    }
  },
  watch: {
    google: function () {
      // map is loaded globally
      // only load it once
      this.$store.commit('setGoogleMapsLoaded')
    }
  },
  mounted () {
    this.$gmapApiPromiseLazy().then(() => {
      // Set the map bounds after the map is actually loaded
      this.setMapBounds()
    })
  },
  created () {
    if (this.gmapsLoaded === false) {
      this.$store.commit('setGoogleMapsLoaded')

      // This runs if we haven't loaded a map yet
      loadGmapApi({
        key: process.env.GMAPS
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Elements/GoogleMaps.vue